import { render } from "./PatientsListPage.vue?vue&type=template&id=7657c6f0&ts=true"
import script from "./PatientsListPage.vue?vue&type=script&lang=ts"
export * from "./PatientsListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__